import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styles } from '../../anchor-panel-898efaa4.js';
import { filterAnchorableBlocks } from './anchorUtils.js';
import FilterDropdownElement from './FilterDropdownElement.js';
import AnchorableElement from './AnchorableElement.js';
import FilterDropdown from './FilterDropdown.js';
import '../../style-inject.es-746bb8ed.js';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-common/libs/imageUtils';
import './consts.js';
import '../Icons/AnchorsThumbnails/ParagraphIcon.js';
import '../Icons/AnchorsThumbnails/H1Icon.js';
import '../Icons/AnchorsThumbnails/H2Icon.js';
import '../Icons/AnchorsThumbnails/H3Icon.js';
import '../Icons/AnchorsThumbnails/H4Icon.js';
import '../Icons/AnchorsThumbnails/H5Icon.js';
import '../Icons/AnchorsThumbnails/H6Icon.js';
import '../Icons/AnchorsThumbnails/CodeBlockIcon.js';
import '../Icons/AnchorsThumbnails/BlockQuoteIcon.js';
import '../Icons/AnchorsThumbnails/ImageIcon.js';
import '../Icons/AnchorsThumbnails/GalleryIcon.js';
import '../Icons/AnchorsThumbnails/VideoIcon.js';
import '../Icons/AnchorsThumbnails/MapIcon.js';
import '../Icons/AnchorsThumbnails/ButtonIcon.js';
import '../Icons/AnchorsThumbnails/GiphyIcon.js';
import '../Icons/AnchorsThumbnails/FileIcon.js';
import 'classnames';
import 'lodash';
import 'wix-rich-content-ui-components';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class AnchorPanel extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "scrollPanelToSelectedAnchor", () => {
      const { anchorValues } = this.props;
      if (anchorValues.anchor) {
        const target = this.scrollRef.current;
        target.parentNode.scrollTop = target.offsetTop - target.parentNode.offsetTop;
      }
    });
    __publicField(this, "onChange", (changes, options = {}) => {
      this.props.onChange({
        anchor: changes.key,
        defaultName: options.defaultName
      });
    });
    __publicField(this, "filterChanged", (newFilter) => {
      this.setState({ filter: newFilter });
    });
    __publicField(this, "renderEmptyState", () => {
      const { styles: styles2 } = this;
      const { t } = this.props;
      return /* @__PURE__ */ React.createElement("div", { className: styles2.AnchorPanel_emptyStateContainer }, /* @__PURE__ */ React.createElement("div", { className: styles2.AnchorPanel_emptyStateTitle }, t("LinkTo_Modal_Section_EmptyState_Title")), /* @__PURE__ */ React.createElement("div", { className: styles2.AnchorPanel_emptyStateText }, t("LinkTo_Modal_Section_EmptyState_Text")));
    });
    __publicField(this, "anchorableElementClicked", (block, { defaultName }, e) => {
      const { anchorValues } = this.props;
      const isSelected = anchorValues.anchor === block.key;
      if (isSelected) {
        const { onEnter } = this.props;
        onEnter && onEnter(e);
      } else {
        this.onChange(block, { defaultName });
      }
    });
    const { theme, t } = props;
    this.styles = mergeStyles({ styles, theme });
    this.state = {
      filter: {
        value: "all",
        component: () => /* @__PURE__ */ React.createElement(FilterDropdownElement, { label: t("LinkTo_Modal_Section_Filter_All"), theme: this.styles })
      }
    };
    this.scrollRef = React.createRef();
  }
  componentDidMount() {
    this.scrollPanelToSelectedAnchor();
  }
  render() {
    const { styles: styles2 } = this;
    const { filter } = this.state;
    const { ariaProps, t, anchorValues, anchorableBlocksData, theme, blockPreview } = this.props;
    const { anchorableBlocks } = anchorableBlocksData;
    const filteredAnchorableBlocks = filter.value === "all" ? anchorableBlocks : filterAnchorableBlocks(anchorableBlocks, filter.value);
    return anchorableBlocks.length === 0 ? this.renderEmptyState() : /* @__PURE__ */ React.createElement("div", __spreadProps(__spreadValues({ className: styles2.AnchorPanel_Content }, ariaProps), { role: "form" }), /* @__PURE__ */ React.createElement("div", { className: styles2.AnchorPanel_header }, /* @__PURE__ */ React.createElement("div", { className: styles2.AnchorPanel_title }, t("LinkTo_Modal_Section_Title")), /* @__PURE__ */ React.createElement(
      FilterDropdown,
      {
        anchorableBlocksData,
        t,
        theme,
        filterChanged: this.filterChanged,
        filter
      }
    )), /* @__PURE__ */ React.createElement("div", { className: styles2.AnchorPanel_anchorsElementsContainer }, filteredAnchorableBlocks.map((block) => /* @__PURE__ */ React.createElement(
      "div",
      {
        key: block.key,
        ref: anchorValues.anchor === block.key ? this.scrollRef : void 0
      },
      /* @__PURE__ */ React.createElement(
        AnchorableElement,
        {
          dataHook: block.key,
          block,
          theme: styles2,
          onClick: (args, e) => this.anchorableElementClicked(block, __spreadValues({}, args), e),
          isSelected: anchorValues.anchor === block.key,
          t,
          blockPreview
        }
      )
    ))));
  }
}
AnchorPanel.propTypes = {
  anchorableBlocksData: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  anchorValues: PropTypes.shape({
    anchor: PropTypes.string
  }).isRequired,
  ariaProps: PropTypes.object,
  onEnter: PropTypes.func,
  onEscape: PropTypes.func,
  placeholder: PropTypes.string,
  blockPreview: PropTypes.func
};

export { AnchorPanel as default };
//# sourceMappingURL=AnchorPanel.js.map
